<template>
  <div>
    <highcharts :constructorType="'mapChart'" class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import worldMap from '@highcharts/map-collection/custom/world.geo.json'
import { Chart } from 'highcharts-vue'
import Highcharts from "highcharts";
import Maps from "highcharts/modules/map";
Maps(Highcharts);

export default {
  props: ['chartData'],
  components: {
      highcharts: Chart 
  },
  computed: {
    chartOptions() {
      return {
          chart: {
            map: worldMap,
            height: 720,
          },
          
          legend: {
              enabled: false
          },

          mapNavigation: {
              enabled: true,
              buttonOptions: {
                  verticalAlign: 'bottom'
              }
          },
          credits: {
            enabled: false
          },
        ...this.chartData
      };
    }
  }
};
</script>
